export const envs = {
    //baseUrl : "https://localhost:44311",
    baseUrl: "https://app-touch-np-eu2-01.azurewebsites.net",
    //baseUrl: "https://app-touch-prod-eu2-01.azurewebsites.net",

    //frontUrl: "http://localhost:3000"
    frontUrl: "https://touch-np.cloud-effem.com",
    //frontUrl: "https://touch.cloud-effem.com",
    //frontUrl: "https://app-touch-np-eu2-02.azurewebsites.net",
    //frontUrl: "https://app-touch-prod-eu2-02.azurewebsites.net",
}